import { Link } from '@dtx-company/flow-codegen/src/page/generated.types'
import { PageType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { SocialFormInputType } from './SocialForm.constants'
import { UseFormMethods } from 'react-hook-form-deprecated'

export enum SocialFormFields {
  INSTAGRAM = 'instagram',
  TIKTOK = 'tiktok',
  SNAPCHAT = 'snapchat',
  LINK = 'link',
  TWITTER = 'twitter',
  LINKEDIN = 'linkedin',
  VENMO = 'venmo',
  CASHAPP = 'cashapp',
  YOUTUBE = 'youtube',
  FACEBOOK = 'facebook',
  SPOTIFY = 'spotify',
  BIGIMAGE = 'bigImage',
  EMAIL = 'email',
  SMS = 'sms',
  CALL = 'call',
  PDF = 'pdf'
}

export const SocialFormFieldsHandles = [
  SocialFormFields.INSTAGRAM,
  SocialFormFields.TIKTOK,
  SocialFormFields.VENMO,
  SocialFormFields.SNAPCHAT,
  SocialFormFields.TWITTER,
  SocialFormFields.CASHAPP
]

export const SocialFormFieldsWidgets = [
  SocialFormFields.BIGIMAGE,
  SocialFormFields.PDF,
  SocialFormFields.EMAIL,
  SocialFormFields.SMS,
  SocialFormFields.CALL
]

export const SocialFormFieldsContactInfo = [
  SocialFormFields.EMAIL,
  SocialFormFields.SMS,
  SocialFormFields.CALL
]

export type SocialLinkMapType = { [key in SocialFormFields]: Link | null }

export type SocialFormContactInfoType = { [key in SocialFormFields]?: string }

export interface SocialFormProps {
  advanceStep: () => void
  isFlowtagOnboarding?: boolean
  isCombinedFunnelMobile?: boolean
  hideFileInputs?: boolean
}

export interface SocialFormInputs {
  [SocialFormFields.INSTAGRAM]: string
  [SocialFormFields.TIKTOK]: string
  [SocialFormFields.SNAPCHAT]: string
  [SocialFormFields.LINK]: string
  [SocialFormFields.TWITTER]: string
  [SocialFormFields.LINKEDIN]: string
  [SocialFormFields.VENMO]: string
  [SocialFormFields.CASHAPP]: string
  [SocialFormFields.YOUTUBE]: string
  [SocialFormFields.FACEBOOK]: string
  [SocialFormFields.SPOTIFY]: string
  [SocialFormFields.BIGIMAGE]: string
  [SocialFormFields.EMAIL]: string
  [SocialFormFields.SMS]: string
  [SocialFormFields.CALL]: string
  [SocialFormFields.PDF]: string
}
export interface SocialFormState {
  handleSubmit: UseFormMethods['handleSubmit']
  values: SocialFormInputs
  page?: PageType | null
  setValue: UseFormMethods['setValue']
  errors: UseFormMethods['errors']
  onSubmit: (
    props: SocialFormInputs,
    sortedSocialInputList: [SocialFormFields, SocialFormInputType][]
  ) => Promise<void>
  handleChange: (fieldName: SocialFormFields) => (e: React.ChangeEvent<HTMLInputElement>) => void
  socialInputList: [SocialFormFields, SocialFormInputType][]
}
